const getAriaDescribedBy = (describedBy, errorId, hasError) => {
  const ids = new Set(
    (describedBy || '')
      .split(/\s+/)
      .filter(id => id && !id.endsWith('-helper-text')),
  );

  if (hasError && errorId) ids.add(errorId);

  return [...ids].join(' ');
};

export default getAriaDescribedBy;
